import { useQuery } from '@tanstack/react-query';
import { DashboardApi } from '../api';
import type { DashboardMetricsResponse } from '../api/Dashboard';

const dashboardApi = new DashboardApi();
const inJest = typeof process !== 'undefined' && process.env.JEST_WORKER_ID != null;

export type DashboardMetricsParams = {
  teamId?: string | null;
  rangePreset?: string;
  playersGroup?: string;
  search?: string;
  startDate?: string | null;
  endDate?: string | null;
};

export const buildDashboardMetricsQueryKey = (params: DashboardMetricsParams) => [
  'dashboard-metrics',
  params.teamId ?? 'no-team',
  params.rangePreset ?? 'default',
  params.playersGroup ?? 'all',
  params.search ?? '',
  params.startDate ?? 'no-start',
  params.endDate ?? 'no-end',
] as const;

export const useDashboardMetrics = (params: DashboardMetricsParams) => {
  const query = useQuery<DashboardMetricsResponse>({
    queryKey: buildDashboardMetricsQueryKey(params),
    queryFn: async () => {
      const result = inJest
        ? await dashboardApi.getMetricsMock(params)
        : await dashboardApi.getMetrics(params);
      if (!result.status) {
        throw new Error('Failed to fetch dashboard metrics');
      }
      return result.data;
    },
  });

  return query;
};

